module.exports = __webpack_public_path__ + "img/kawoon.1bd60d15.jpg";